import { Button, Card, Col, Form, message, Row } from "antd";
import { FC, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import sliderApi from "../../../../api/sliderApi";
import InputField from "../../../../components/InputField";
import InputNumberWrap from "../../../../components/InputNumber";
import Loading from "../../../../components/Loading";
import TopContent from "../../../../components/TopContent";
import PageWrap from "../../../../layout/PageWrap";
import { appRoutes } from "../../../../routes/routes";
import { formItemLayoutSm } from "../../../../utils/constants";
import { loadFile } from "../../../../utils/functions/loadFile";
import { messages } from "../../../../utils/messages";
interface SliderGuestFormProps {
  type: number;
}

const SliderGuestForm: FC<SliderGuestFormProps> = ({ type }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { id } = useParams();
  const [file, setFile]: any = useState();
  const { data, isLoading }: any = useQuery(
    ["guest-slider", id],
    () => sliderApi.getGuestSliderDetails(id),
    {
      enabled: !!id && type === 2,
      onSuccess: (dt: any) => {
        if (dt?.statusCode !== 200) navigate("/404");
      },
    }
  );

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  const [image, setImage]: any = useState();
  const handleUpload = async (file: any) => {
    if (file) {
      setFile(file);
      await loadFile(file);
      setImage(file.urlImg);
    }
  };
  const mutationEdit = useMutation(sliderApi.editGuestSlider, {
    onSuccess: async (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.updateSuccess);
        await queryClient.invalidateQueries("guest-slider");
        navigate(appRoutes.SLIDERS.GUEST.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });
  const mutationAdd = useMutation(sliderApi.addGuestSlider, {
    onSuccess: async (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.addSuccess);
        await queryClient.invalidateQueries("guest-slider");
        navigate(appRoutes.SLIDERS.GUEST.LIST);
        window.scrollTo(0, 0);
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });
  const onSubmit = (dt: any) => {
    const formData = new FormData();
    if (file) formData.append("banner", file);
    formData.set("ten_vi", dt.ten_vi ?? "");
    formData.set("stt", dt.stt ?? "");
    if (type === 2) mutationEdit.mutate({ id: id, data: formData });
    if (type === 1) mutationAdd.mutate(formData);
  };

  return (
    <PageWrap
      title="Slider khách hàng"
      content={
        <>
          <TopContent
            content={
              <Row>
                <Col>
                  <b>Slider khách hàng</b>
                </Col>
              </Row>
            }
          />
          <div className="content">
            {isLoading ? (
              <Loading />
            ) : (
              <Card bordered={false}>
                <Form {...formItemLayoutSm} className="slider-form">
                  {(image || data?.data?.photo) && (
                    <div className="cash_img">
                      <img
                        src={
                          image ??
                          process.env.REACT_APP_DOMAIN + data?.data?.photo
                        }
                        alt=""
                      />
                    </div>
                  )}
                  <InputField
                    isImage={true}
                    name="banner"
                    control={control}
                    rules={
                      type === 1
                        ? {
                            required: "Vui lòng chọn hình ảnh",
                          }
                        : undefined
                    }
                    label="Hình ảnh"
                    errorMsg={errors?.banner?.message}
                    onChange={(e: any) => {
                      handleUpload(e.target.files?.[0]);
                    }}
                  />
                  <InputField
                    label="Tên"
                    name="ten_vi"
                    control={control}
                    setValue={setValue}
                    defaultValue={data?.data?.ten_vi}
                    errorMsg={errors?.ten_vi?.message}
                    rules={{
                      required: "Vui lòng nhập tên",
                    }}
                  />
                  <InputNumberWrap
                    label="STT"
                    name="stt"
                    control={control}
                    defaultValue={data?.data?.stt ?? 1}
                    onBlur={(e: any) => {
                      if (e.target.value === "") setValue("stt", 1);
                    }}
                    min={1}
                  />
                  <Row justify="start" gutter={[10, 0]}>
                    <Col>
                      <Button
                        type="primary"
                        danger
                        onClick={handleSubmit(onSubmit)}
                      >
                        Lưu
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        onClick={() => navigate(appRoutes.SLIDERS.GUEST.LIST)}
                      >
                        Hủy
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card>
            )}
          </div>
        </>
      }
    />
  );
};

export default SliderGuestForm;
